import Script from 'next/script';

export function GoogleMapsApi({
  googleMapsApiKey,
  onLoad,
}: Props): JSX.Element {
  return (
    <Script
      strategy="afterInteractive"
      src={`https://maps.googleapis.com/maps/api/js?key=${googleMapsApiKey}&libraries=places&language=en`}
      onLoad={onLoad}
    />
  );
}

type Props = {
  googleMapsApiKey: string;
  callbackName?: string;
  onLoad?: () => void;
};
